import { render, staticRenderFns } from "./CompDiversityClickableCard.vue?vue&type=template&id=bdb6fda6&scoped=true"
import script from "./CompDiversityClickableCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompDiversityClickableCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb6fda6",
  null
  
)

export default component.exports